import React from 'react';

export const GlobeFilled = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.99988 11.9999C1.99988 6.48688 6.48588 1.99988 11.9999 1.99988C17.5139 1.99988 21.9999 6.48688 21.9999 11.9999C21.9999 17.5139 17.5139 21.9999 11.9999 21.9999C6.48588 21.9999 1.99988 17.5139 1.99988 11.9999ZM6.98789 16.0726C6.28689 16.0726 5.59789 15.9606 4.96189 15.7996C6.31589 18.2986 8.96289 19.9996 11.9999 19.9996C13.1009 19.9996 14.1499 19.7766 15.1059 19.3716C15.1049 19.0926 14.9359 18.8076 14.5919 18.2906L14.5785 18.2704C14.4519 18.079 14.3239 17.8855 14.2089 17.6846C13.2219 15.9676 13.9539 14.7386 14.6009 13.6556L14.6999 13.4876C14.9499 13.0666 14.9669 12.6056 14.9869 12.0226C15.0009 11.6116 15.0179 11.1466 15.1259 10.6526C15.5339 8.78459 17.5619 8.31759 18.9889 8.11859C18.2239 6.74359 17.0639 5.62059 15.6639 4.89659C15.3679 5.61159 14.8899 6.25959 14.2469 6.76259C13.9459 6.99759 13.6339 7.18459 13.3319 7.36459L13.3265 7.36783C12.8358 7.66146 12.4122 7.91493 12.2129 8.27959C11.8409 8.96259 11.8409 9.73259 11.8409 10.6236C11.8409 12.0036 11.8409 13.7206 10.1249 15.0626C9.17089 15.8096 8.06789 16.0726 6.98789 16.0726Z"
      fill="currentColor"
    />
  </svg>
);
